//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObject.js";
import "../Drawings/Drawings.SectionLineSegmentPointListBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"RotationPoint",1,"Point",0],[0,"SectionLineOnlyPlacementOrigin",1,0],[1,"SegmentLocation",0,"Drawings.SectionLineSegmentPointListBuilder",0],[1,"SegmentLocationForSecondLeg",0,"Drawings.SectionLineSegmentPointListBuilder",0],[0,"SingleLeg",1,0]],[[[],"UpdateAfterParentViewMove",{},0,0],[["curve","startParam","endParam"],"SetLongitudinalSectionData",{},3,0],[["curve","startParam","endParam"],"GetLongitudinalSectionData",{},0,0]],[]];
SPLM.Drawings.SectionLineSegmentsBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Drawings.SectionLineSegmentsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;